import { IconoTallerza } from '@/marca/Logo';

export function CargandoPantalla() {
  return (
    <div className="grid min-h-dvh place-items-center bg-bg" role="status" aria-live="polite">
      <div className="flex flex-col items-center gap-4">
        <IconoTallerza size={56} className="animate-pulso-suave" />
        <span className="sr-only">Cargando…</span>
      </div>
    </div>
  );
}
